import React from 'react'

import { useAgent } from '../AgentProvider'

import { initialState, typingReducer, Actions } from './reducer'

const TypingContext = React.createContext(null)

const TypingProvider = ({ children }) => {
  const { currentUser } = useAgent()

  const [typing, dispatch] = React.useReducer(typingReducer, initialState)

  // Gets names of people typing
  const getTyping = React.useCallback(
    id => {
      if (!typing.has(id)) {
        return []
      }

      return typing.get(id).map(obj => obj.name)
    },
    [typing]
  )

  // Removes a typer
  const unsetTyping = React.useCallback((id, userID, name) => {
    dispatch({ type: Actions.UNSET, id, userID, name })
  }, [])

  // Sets and automatically clears typing status
  const setTyping = React.useCallback(
    (id, userID, name) => {
      const cb = () => unsetTyping(id, userID, name)
      dispatch({ type: Actions.SET, id, userID, name, cb })
    },
    [unsetTyping]
  )

  // Handles typing notification
  const handleTypingEvent = React.useCallback(
    msg => {
      const me = currentUser()?.id
      const { content, sessionId } = msg
      const userID = content.user.id

      if (userID !== me) {
        const id = sessionId ?? userID
        const name = content.user.name
        setTyping(id, userID, name)
      }
    },
    [currentUser, setTyping]
  )

  return (
    <TypingContext.Provider
      value={{ getTyping, setTyping, unsetTyping, handleTypingEvent }}
    >
      {children}
    </TypingContext.Provider>
  )
}

export default TypingProvider

export const useTyping = () => React.useContext(TypingContext)
